import { i18n } from '@/locale'
import store from '@/store'

function formatErrorString (errors) {
  const formErrors = {}
  errors.forEach(error => {
    formErrors[error.field] = []
    error.field_errors.forEach(fieldError => {
      const errorString = formatFieldError(
        fieldError,
        i18n.t('fields.' + error.field)
      )
      if (formErrors[error.field].indexOf(errorString) < 0) {
        formErrors[error.field].push(errorString)
      }
    })
  })
  return formErrors
}

function formatFieldError (fieldError, fieldName) {
  var errorString = ''
  if (fieldError.name === 'INVALID_OBJECT') {
    errorString = i18n.t('error.bad_request.' + fieldError.name, {
      field_name: fieldName,
    })
    fieldError.value.forEach(value => {
      value.field_errors.forEach(valueFieldError => {
        errorString += formatFieldError(
          valueFieldError,
          i18n.t('fields.' + value.field)
        )
      })
    })
  } else if (fieldError.name === 'INVALID_ARRAY_ITEM') {
  } else if (fieldError.name === 'INVALID_FORMAT_ARRAY_ELEMENTS') {
    var errors = ''
    fieldError.value.forEach(valueFieldError => {
      errors +=
        formatFieldError(
          valueFieldError.error,
          i18n.t('error.bad_request.INDEX', {
            index: valueFieldError.index,
          })
        ) + '\n    '
    })
    errorString += i18n.t('error.bad_request.' + fieldError.name, {
      field_name: fieldName.toLowerCase(),
      errors: errors,
    })
  } else {
    errorString = i18n.t('error.bad_request.' + fieldError.name, {
      value: fieldError.value,
      field_name: fieldName,
    })
  }
  return errorString
}

export class ErrorManager {
  manageError (error, disableStatusHandling) {
    if (!!disableStatusHandling && !!disableStatusHandling[error.status]) {
      return
    }
    switch (error.status) {
    case 400:
      store.commit('state/setFormErrors', formatErrorString(JSON.parse(error.body)))
      break
    case 401:
      store.dispatch('auth/signOut').catch(() => {})
      break
    case 403:
      if (JSON.parse(error.body).message === 'User does not exist.') {
        store.dispatch('auth/signOut').catch(() => {})
      }
      store.commit('state/setMessage', { text: JSON.parse(error.body).message, color: 'error' })
      break
    case 404:
      if (!error.url || !error.url.includes('defaults')) {
        store.commit('state/setMessage', { text: i18n.t('error.not_found'), color: 'error' })
      }
      break
    case 408:
      // FIXME: handle error
      break
    case 409:
      // FIXME: check if handling is valid
      switch (JSON.parse(error.body).message) {
      case 'Username is already in use.':
        store.commit('state/setFormErrors', { username: ['errors.conflict.USERNAME_IN_USE'] })
        break
      }
      break
    case 422:
      // FIXME: handle error
      break
    case 0:
      store.commit('state/setMessage', { text: i18n.t('error.server_disconnected'), color: 'error' })
      break
    case 500:
      store.commit('state/setMessage', { text: i18n.t('error.server_error'), color: 'error' })
      break
    }
  }
}
